export function findUpProperty(node, key, defaultValue) {
  let value

  while (node) {
    value = node[key]
    if (value !== undefined) return value
    node = node.$parent
  }

  return defaultValue
}

export function getUuid() {
  return new Date().getTime()
}

export function evalFunc(context, fn, options = {}) {
  const func = new Function('options', fn)

  try {
    return func.call(context, options)
  } catch (e) {
    console.error(e)
  }
}

// 生成部门树结构
export function buildUnitTree(units) {
  const unitsMap = units.reduce((map, unit) => {
    unit.value = unit.unitCode
    unit.text = unit.unitName
    unit.children = []
    map[unit.unitCode] = unit
    return map
  }, {})

  const result = []
  for (const key in unitsMap) {
    const unit = unitsMap[key]
    if (unit.parentUnit && unitsMap[unit.parentUnit]) {
      unitsMap[unit.parentUnit].children.push(unit)
    } else {
      result.push(unit)
    }
  }
  return result
}
export function buildTree(data) {
  if (!data) {
    return []
  }

  const temp = {}
  const tree = []

  data.forEach(v => {
    v.checked = false
    v.children = []
    if (!v.key) {
      v.key = v.id
    }
    if (!v.parent) {
      v.parent = v.pid
    }
    if (!v.title) {
      v.title = v.text
    }
    temp[v.key] = JSON.parse(JSON.stringify(v))
  })

  for (const key in temp) {
    if (temp[key].parent !== 0 && temp[temp[key].parent]) {
      // if (!temp[temp[key].parent].children) {
      //   temp[temp[key].parent].children = []
      // }

      temp[temp[key].parent].expand = false
      temp[temp[key].parent].children.push(temp[key])
    } else {
      temp[key].parent = 0
      tree.push(temp[key])
    }
  }

  return tree
}

export function flatTree(tree, level = 0, hide = false) {
  let flat = []

  for (let i = 0; i < tree.length; i++) {
    const node = tree[i]
    node._level = level
    node._hide = hide
    flat.push(node)

    if (node.children instanceof Array) {
      const h = hide || !node._expand
      flat = flat.concat(flatTree(node.children, level + 1, h))
    }
  }

  return flat
}

export function dateToString(value) {
  let date = new Date()

  if (value) {
    date = new Date(value)
  }

  const y = date.getFullYear()
  const m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  const d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()

  return `${y}-${m}-${d}`
}

export function timeToString(value) {
  let date = new Date()

  if (value) {
    date = new Date(value)
  }

  const y = date.getFullYear()
  const m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  const d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  const H = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  const M = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  const S = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()

  return `${y}-${m}-${d} ${H}:${M}:${S}`
}

export function getLastMonth() { // 获取上个月日期
  var date = new Date()
  var year = date.getFullYear()
  var month = date.getMonth()
  var day = date.getDate()
  if (month === 0) {
    year = year - 1
    month = 12
  }
  return `${year}-${month}-${day}`
}

export function monthRangeDateToString() {
  return [getLastMonth(), dateToString()]
}

export function deepCopy(obj) {
  return JSON.parse(JSON.stringify(obj))
}

export function shuffle(data) {
  if (!Array.isArray(data)) {
    data = data.data
  }

  data.sort(() => {
    return Math.random() > 0.5 ? 1 : -1
  })
}

export function arraySet(data) {
  return Array.from(new Set(data)).sort(sort)
}

function sort(n1, n2) {
  if (!isNaN(n1 * 1.0) && !isNaN(n2 * 1.0)) {
    return n1 * 1.0 - n2 * 1.0
  }

  return n1 > n2 ? 1 : -1
}

// 将数组指定位置的元素上移一位
export function arrayUpGo(array, index) {
  if (index !== 0) {
    array[index] = array.splice(index - 1, 1, array[index])[0]
  } else {
    array.push(array.shift())
  }
}

// 将数组指定位置的元素下移一位
export function arrayDownGo(array, index) {
  if (index !== array.length - 1) {
    array[index] = array.splice(index + 1, 1, array[index])[0]
  } else {
    array.unshift(array.splice(index, 1)[0])
  }
}
